import { render } from "./DeleteFoundryModal.vue?vue&type=template&id=5452e6da"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"

import "./DeleteFoundryModal.vue?vue&type=style&index=0&id=5452e6da&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__